import { useState } from 'react';
import { IoArrowBackOutline, IoArrowForwardCircleOutline, IoArrowForwardOutline } from 'react-icons/io5';
import { BsBox, BsTable } from 'react-icons/bs';
import { FaRegQuestionCircle } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { useSpring, animated } from 'react-spring';
import ProductReportComponent from '../../components/reports/ProductReportComponent';
import ProductReports from '../../components/reports/ProductReportComponent';
import { ProductReportComponentFilter } from '../../components/reports/OsProductReportComFilter';
import { MwButton } from '../../components/ui';

// مكون لعرض أيقونة مع تأثير حركة مخصص بناءً على الخاصية animationType
const IconCard = ({ onClick, icon, text, animationType }) => {
  const animationParams =
    animationType === 'rotate'
      ? {
          from: { transform: 'rotate(0deg)' },
          to: { transform: 'rotate(360deg)' },
          loop: true,
          config: { duration: 2000 },
        }
      : animationType === 'openClose'
      ? {
          from: { transform: 'scaleY(0.8)' },
          to: { transform: 'scaleY(1)' },
          loop: { reverse: true },
          config: { duration: 1500 },
        }
      : {
          from: { transform: 'scale(1)' },
          to: { transform: 'scale(1)' },
        };

  const animation = useSpring(animationParams);

  return (
    <div
      onClick={onClick}
      className="flex flex-col items-center justify-center p-6 bg-white border border-gray-200 rounded-lg cursor-pointer hover:shadow-md hover:border-[#251658] transition-all"
    >
      <animated.div style={animation}>
        {icon}
      </animated.div>
      <span className="text-center font-medium text-[#251658] mt-2">{text}</span>
    </div>
  );
};

const OSProductReport = () => {
  const [mode, setMode] = useState('Icons');
  const [reportType, setReportType] = useState('');
  const [idSelected, setIdSelected] = useState();
  const { t, i18n } = useTranslation('global');
  const isRTL = i18n.dir() === 'rtl';

  const handleBack = () => {
    setMode('Icons');
    setReportType('');
  };

  const handleProductMovementClick = () => {
    setMode('Report');
    setReportType('Movement');
  };

  const handleFilterClick = () => {
    setMode('Report');
    setReportType('Filter');
  };

   const fade = useSpring({
    opacity: mode === 'Icons' ? 1 : 0,
    config: { duration: 300 },
  });

   const slide = useSpring({
    transform: mode === 'Report' ? 'translateX(0%)' : 'translateX(100%)',
    config: { tension: 220, friction: 30 },
  });

  return (
    <div className="min-h-screen bg-white p-4">
      {mode === 'Icons' ? (
        <animated.div style={fade} className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
           <IconCard
            onClick={handleProductMovementClick}
            text="تقرير حركة المنتج"
            icon={<BsBox size={32} className="text-[#251658]" />}
            animationType="rotate"
          />

           <IconCard
            onClick={handleFilterClick}
            text="تقرير بيانات المنتج"
            icon={<BsTable size={32} className="text-[#251658]" />}
            animationType="openClose"
          />
        </animated.div>
      ) : mode === 'Report' && (
        <animated.div style={slide} className="bg-white">
          <div className="p-2">
            <div className="flex justify-end">
              <MwButton
                onClick={handleBack}
                className="flex items-center justify-end w-full"
                type="saveBtn"
                size="sm"
              >
                
{t('reports.product_Report')}            
      {isRTL ? <IoArrowBackOutline /> : <IoArrowForwardOutline />}

               </MwButton>
            </div>

            {reportType === 'Movement' && (
              <div>
                <ProductReports idSelected={idSelected} setIdSelected={setIdSelected} />
              </div>
            )}

            {reportType === 'Filter' && (
              <div>
                <ProductReportComponentFilter />
              </div>
            )}
          </div>
        </animated.div>
      )}
    </div>
  );
};

export default OSProductReport;
